@if (!user || loading) {
  <div class="offcanvas-header border-bottom-0">
    <h5 class="offcanvas-title placeholder-glow">
      <span class="placeholder col-12"></span>
    </h5>
    <button type="button" class="btn-close" (click)="activeSlideout.close()" aria-label="Close">
    </button>
  </div>
  <div class="offcanvas-body placeholder-glow">
    <div class="empty">
      <div class="spinner-border text-blue"></div>
    </div>
  </div>
}

@if (user) {
  <div class="offcanvas-header border-bottom-0">
    <h5 class="offcanvas-title">{{ user.name }}</h5>
    <button type="button" class="btn-close" (click)="activeSlideout.close()" aria-label="Close">
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="datagrid">
      <div class="datagrid-item">
        <div class="datagrid-title">{{ 'admin.userTable.headers.emailAddress' | translate }}</div>
        <div class="datagrid-content">
          @if (user.emailAddress) {
            <a [href]="'mailto:'+user.emailAddress">
              {{ user.emailAddress }}
            </a>
          }
          @if (!user.emailAddress) {
            &mdash;
          }
        </div>
      </div>
      <div class="datagrid-item">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}

